import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { AddApiMessagePayload, UpdateApiMessagePayload } from './apiMessage.types';

const addApiMessage = (client: AxiosInstance) => async (payload: AddApiMessagePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.ADD_API_MESSAGE, payload)).data;
};

const updateApiMessage = (client: AxiosInstance) => async (payload: UpdateApiMessagePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_API_MESSAGE, payload)).data;
};

export const apiMessageMutations = {
  addApiMessage,
  updateApiMessage,
};
